import { useQuery } from '@tanstack/react-query';
import { API } from 'network/api';
import { useSelector } from 'react-redux';

import type { TaskDetail } from 'screens/task-management/types';
import { selectUserEmail } from 'store/auth/selectors';

const useTaskDetailQuery = (taskId: string | null) => {
  const userEmail = useSelector(selectUserEmail);

  const query = useQuery<TaskDetail>({
    queryKey: ['taskDetail', taskId, { userEmail }],
    queryFn: async () => {
      const response = await API.get<TaskDetail>(
        `/taskassignment/v2.1/${taskId}`,
      );
      return response?.data;
    },
    enabled: !!taskId,
    staleTime: 1000 * 20, // 20 seconds
  });

  return query;
};

export default useTaskDetailQuery;
